export default __webpack_public_path__ + "static/media/rae-dancing.cd6f5a00.mp4";